import React from 'react'
import {
    Facebook,
    Instagram,
    Linkedin,
    MapPin,
    Phone,
    Mail,
    Building,
    GraduationCap,
    LibraryBig,
    BookOpen,
    Keyboard,
    Sheet,
    ShieldCheck,
    NotebookPen,
    HandHelping
} from 'lucide-react'
import { Link } from "react-router-dom"
import MayaLogo from "../assets/maya.jpg"
import { motion } from 'framer-motion'

const FooterSection = ({ title, children }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center md:text-left"
    >
        <p className="text-sm font-bold tracking-widest uppercase text-yellow-300 flex items-center gap-2 justify-center md:justify-start">
            {children[0]}
            {title}
        </p>
        <ul className="mt-6 space-y-4">
            {children.slice(1)}
        </ul>
    </motion.div>
)

const Footer = () => {
    return (
        <div className='relative bg-[#0e4d38] text-white'>
            <div className="px-4 py-16 mx-auto sm:px-6 lg:px-8 max-w-7xl">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-y-12 gap-x-12">
                    {/* University Info Section */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                        className="col-span-1 md:col-span-2 lg:col-span-2 lg:pr-8 text-center md:text-left"
                    >
                        <img
                            className="w-auto mx-auto md:mx-0 rounded-xl max-w-[300px] mb-6"
                            src={MayaLogo}
                            alt="Maya Devi University Logo"
                        />

                        <div className="space-y-4 text-center md:text-left">
                            <div className="flex items-center justify-center md:justify-start gap-3">
                                <Phone size={20} className="text-yellow-300" />
                                <span>0135-2698602</span>
                            </div>
                            <div className="flex items-center justify-center md:justify-start gap-3">
                                <Mail size={20} className="text-yellow-300" />
                                <span>info@maya.edu.in</span>
                            </div>
                            <div className="flex items-center justify-center md:justify-start gap-3">
                                <MapPin size={20} className="text-yellow-300" />
                                <span>Selaqui, Pharma City, Dehradun, Uttarakhand-248011</span>
                            </div>
                        </div>

                        <div className="flex items-center justify-center md:justify-start space-x-4 mt-6">
                            <motion.a
                                href="https://m.facebook.com/maya.ddun/"
                                whileHover={{ scale: 1.2 }}
                                className="text-white hover:text-yellow-300 transition-colors"
                            >
                                <Facebook size={24} />
                            </motion.a>
                            <motion.a
                                href="https://www.instagram.com/mayadeviuniversity "
                                whileHover={{ scale: 1.2 }}
                                className="text-white hover:text-yellow-300 transition-colors"
                            >
                                <Instagram size={24} />
                            </motion.a>
                            <motion.a
                                href="https://in.linkedin.com/company/maya-devi-univeristy"
                                whileHover={{ scale: 1.2 }}
                                className="text-white hover:text-yellow-300 transition-colors"
                            >
                                <Linkedin size={24} />
                            </motion.a>
                        </div>
                    </motion.div>

                    {/* Quick Links */}
                    <FooterSection
                        title="Quick Links"
                        children={[
                            <Keyboard size={16} />,
                            <Link
                                to="https://samadhaan.ugc.ac.in"
                                className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            >
                                <HandHelping size={16} /> UGC SAMADHAAN
                            </Link>,
                            <Link
                                to="/contact-us"
                                className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            >
                                <BookOpen size={16} /> Contact Us
                            </Link>,
                            <Link
                                to="/placements"
                                className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            >
                                <GraduationCap size={16} /> Placements
                            </Link>,
                            <Link
                                to="/career"
                                className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            >
                                <Keyboard size={16} /> Career
                            </Link>,
                            <Link
                                to="/blogs"
                                className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            >
                                <NotebookPen size={16} /> Blogs
                            </Link>,
                            <Link
                                to="/PrivacyPolicy"
                                className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            >
                                <NotebookPen size={16} /> Privacy Policy
                            </Link>,
                            <Link
                                to="/TermsAndConditions"
                                className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            >
                                <NotebookPen size={16} /> Terms & Conditions
                            </Link>,
                            <a
                                href="/admission/refund-policy"
                                className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            >
                                <Sheet size={16} /> Refund Policy
                            </a>,


                        ]}
                    />

                    {/* Our Schools */}
                    <FooterSection
                        title="Our Schools"
                        children={[
                            <LibraryBig size={16} />,
                            <ul className="mt-6 space-y-4">
                                <li>
                                    <Link to="/programmes/ug-courses/best-computer-engineering-college-in-dehradun-uttarakhand" onClick={() => window.scrollTo(0, 0)} className="text-white transition-all duration-200 hover:text-yellow-300 focus:text-yellow-300 flex items-center gap-2 justify-center md:justify-start">
                                        School of Computer Engineering & Applications
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/programmes/ug-courses/sciences" onClick={() => window.scrollTo(0, 0)} className="text-white transition-all duration-200 hover:text-yellow-300 focus:text-yellow-300 flex items-center gap-2 justify-center md:justify-start">
                                        School of  Life & Applied sciences
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/programmes/ug-courses/pharmacy" onClick={() => window.scrollTo(0, 0)} className="text-[white] transition-all duration-200 hover:text-yellow-300 focus:text-yellow-300 flex items-center gap-2 justify-center md:justify-start">
                                        School of Pharmacy
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/programmes/ug-courses/agriculture" onClick={() => window.scrollTo(0, 0)} className="text-[white] transition-all duration-200 hover:text-yellow-300 focus:text-yellow-300 flex items-center gap-2 justify-center md:justify-start">
                                        School of Agriculture
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/programmes/ug-courses/best-engineering-college-in-dehradun-uttarakhand" onClick={() => window.scrollTo(0, 0)} className="text-[white] transition-all duration-200 hover:text-yellow-300 focus:text-yellow-300 flex items-center gap-2 justify-center md:justify-start">
                                        School of Engineering
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/programmes/ug-courses/management-and-commerce" onClick={() => window.scrollTo(0, 0)} className="text-[white] transition-all duration-200 hover:text-yellow-300 focus:text-yellow-300 flex items-center gap-2 justify-center md:justify-start">
                                        School of Commerce & Management
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/programmes/ug-courses/hotel-management-and-tourism" onClick={() => window.scrollTo(0, 0)} className="text-[white] transition-all duration-200 hover:text-yellow-300 focus:text-yellow-300 flex items-center gap-2 justify-center md:justify-start">
                                        School of Hotel Management & Tourism
                                    </Link>
                                </li>
                            </ul>
                        ]}
                    />

                    {/* Admission */}
                    <FooterSection
                        title="Admission"
                        children={[
                            <ShieldCheck size={16} />,
                            <Link
                                to="https://admission.maya.edu.in/"
                                className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            >
                                <BookOpen size={16} /> Online Admission
                            </Link>,
                            // <a
                            //     href="/admission/scholarships"
                            //     className="text-white hover:text-yellow-300 transition-colors flex items-center gap-2 justify-center md:justify-start"
                            // >
                            //     <Keyboard size={16} /> Scholarship
                            // </a>
                        ]}
                    />
                </div>

                <hr className="mt-16 mb-8 border-yellow-300/20" />

                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className="text-sm text-center text-white/70"
                >
                    © {new Date().getFullYear()} Maya Devi University. All Rights Reserved.
                </motion.p>
            </div>
        </div>
    )
}

export default Footer